import { History } from 'history'
import { APP_API_BASE_URL } from '../constants/env'
import store from '../store'
import { ActionType } from '../store/error/actions'
export function navigate(history: History) {
  return (url: string, replace = false): void => {
    store.dispatch({ type: ActionType.CLEAN_ERROR })
    if (replace) {
      history.replace(url)
    } else {
      history.push(url)
    }
  }
}
export function goBack(history: History): () => void {
  return history.goBack
}
export function redirect(location: Location) {
  return (baseUrl: string) => (url: string): void => {
    location.href = `${baseUrl}/${url}`
  }
}
export function redirectToBackendApp(location: Location) {
  return (url: string): void => {
    const formattedURL = url.match(RegExp('^/', 'i')) ? url.slice(1, -1) : url
    location.href = `${APP_API_BASE_URL}/${formattedURL}`
  }
}
export function openInNewTab(location: Location) {
  return (url: string, origin?: string): void => {
    window.open(`${origin ?? location.origin}${url}`)
  }
}
